/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import "typeface-roboto/index.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/theme-dark.css";
import { ThemeProvider } from "@mui/material/styles";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import { createIntl, createIntlCache, RawIntlProvider } from "react-intl";
import { Freeze } from "react-freeze";

import { cssTransition, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Css/toastify.css";

import { createGlobalStyle } from "styled-components";

import theme from "../Theme/theme";

import useStore from "../store";

import Dashboard, { AddWidgetDialog } from "./Dashboard";
import About from "../Tabs/About/About";
import Imprint from "../Tabs/About/Imprint";
import Privacy from "../Tabs/About/Privacy";
import { InactiveOverlay } from "../Components";

library.add(fas, fab);

const cache = createIntlCache();

const intl = createIntl({
    locale: "de-DE",
    messages: {},
}, cache);

/* eslint-disable-next-line no-undef */
const onBrowser = _isBrowser;

const toastifyTransition = cssTransition({
    enter: "toastify-fade-in",
    exit: "toastify-fade-out",
});
export default function Main() {
    const disableAnimation = true; // TODO: put in store
    const darkMode = useStore((store) => store.app.darkMode);
    const isAuthenticated = useStore((store) => store.app.isAuthenticated);
    const sleep = useStore((store) => store.app.sleep);
    const sidebars = useStore((store) => store.dashboard.sidebars);
    const menuWidth = useStore((store) => store.menu.width);
    const currentDialog = useStore((store) => store.dashboard.dialogs.currentOpenDialog);

    const GlobalStyle = createGlobalStyle`
      .modal-main {
          //top: ${darkMode ? 52 : 40}px;
        bottom: 21px;
        top: ${onBrowser ? 30 : 40}px;
        left: ${menuWidth + 1}px;
        right: ${(sidebars.right.enabled ? sidebars.right.width : 0) || 0}px;
      }

      .modal-backdrop-main {
          //top: ${darkMode ? 52 : 40}px;
        bottom: 21px;
        top: ${onBrowser ? 30 : 40}px;
        left: ${menuWidth + 1}px;
        right: ${(sidebars.right.enabled ? sidebars.right.width + 10 : 0) || 0}px;
      }
    `;

    React.useEffect(() => {
        if ("webkitSpeechRecognition" in window) {
            console.error("nope");
        }
        console.log();
    }, []);
    return (
        <>
            {useMemo(() => (
                <ThemeProvider theme={theme.set(darkMode, disableAnimation)}>
                    {sleep && (
                        <InactiveOverlay />
                    )}
                    <ToastContainer
                        draggable={false}
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        pauseOnHover
                        theme={darkMode ? "dark" : "light"}
                        transition={toastifyTransition}
                    />
                    <Freeze freeze={sleep}>
                        <ScopedCssBaseline />
                        <GlobalStyle />
                        <div
                            className={darkMode ? "DarkTheme" : "LightTheme"}
                            style={{ height: "100%" }}
                        >
                            {isAuthenticated
                                ? (
                                    <RawIntlProvider value={intl}>
                                        <Dashboard />
                                        <AddWidgetDialog />
                                        {currentDialog === "about" && <About />}
                                        {currentDialog === "imprint" && <Imprint />}
                                        {currentDialog === "privacy" && <Privacy />}
                                    </RawIntlProvider>
                                )
                                : null}
                        </div>
                    </Freeze>
                </ThemeProvider>
            ), [theme, darkMode, isAuthenticated, intl, menuWidth, sidebars.right, currentDialog, sleep])}
        </>
    );
}
